// protected route

import { Navigate } from 'react-router-dom';
import { useAppSelector } from './redux/hooks';
import { selectIsLoggedIn } from './redux/slices/user';

const PreloginRoute = (props: any) => {

        const isLoggedIn = useAppSelector(selectIsLoggedIn);
    const { element } = props;

    return isLoggedIn ? <Navigate to="/" /> : element;
};

export default PreloginRoute;
